/**
 * When a cursor-pagination "page walk" fails (network error or repeated stalls),
 * show the deepest page that is actually in the infinite-query cache.
 *
 * Do **not** reset to page 1 here — that fallback is reserved for
 * `onAnchorMissing` when the saved row id is no longer in the dataset.
 *
 * @returns true when the page was actually lowered, so callers can tell
 *   "we could not reach your page" apart from "nothing to clamp".
 */
export const clampRestoredPageToLoaded = (
	currentPage: number,
	setCurrentPage: (page: number) => void,
	loadedPages: number,
): boolean => {
	if (loadedPages < 1 || currentPage <= loadedPages) {
		return false;
	}
	setCurrentPage(loadedPages);
	return true;
};
